export const fjDealStages = [
  { value: "nouvelle-demande", label: "Nouvelle demande" },
  { value: "qualification", label: "Qualification" },
  { value: "devis-a-preparer", label: "Devis à préparer" },
  { value: "devis-envoye", label: "Devis envoyé" },
  { value: "gagne-fj2l", label: "Gagné, transmis à FJ2L" },
  { value: "formation-realisee", label: "Formation réalisée" },
  { value: "perdu", label: "Perdu" },
];

export const ACTIVE_STAGES = fjDealStages.slice(0, 4).map((s) => s.value);

export const fjDealPipelineStatuses = ["gagne-fj2l", "formation-realisee"];

export const fjDealCategories = [
  { value: "intra", label: "Intra-entreprise" },
  { value: "inter", label: "Inter-entreprises" },
  { value: "sur-mesure", label: "Sur mesure" },
  { value: "inconnu", label: "À préciser" },
];

export const fjNoteStatuses = [
  { value: "cold", label: "Froid", color: "#7dbde8" },
  { value: "warm", label: "Tiède", color: "#e8cb7d" },
  { value: "hot", label: "Chaud", color: "#e88b7d" },
  { value: "in-contract", label: "Client", color: "#a4e87d" },
];

export const fjTaskTypes = [
  { value: "none", label: "Aucun" },
  { value: "call", label: "Appel" },
  { value: "email", label: "Email" },
  { value: "meeting", label: "Rendez-vous" },
  { value: "follow-up", label: "Relance" },
  { value: "devis", label: "Devis" },
];

export const fjCompanySectors = [
  { value: "tpe-pme", label: "TPE / PME" },
  { value: "association", label: "Association" },
  { value: "collectivite", label: "Collectivité" },
  { value: "organisme-formation", label: "Organisme de formation" },
  { value: "independant", label: "Indépendant" },
  { value: "autre", label: "Autre" },
];

export const SOURCE_CHOICES = [
  { id: "contact", name: "Formulaire de contact" },
  { id: "devis", name: "Demande de devis" },
  { id: "orientation", name: "Orientation" },
  { id: "rdv", name: "Appel de 15 min" },
  { id: "email", name: "Email" },
  { id: "manuel", name: "Saisie manuelle" },
];

export const MODALITE_CHOICES = [
  { id: "presentiel", name: "Présentiel" },
  { id: "distanciel", name: "Distanciel" },
  { id: "mixte", name: "Mixte" },
  { id: "inconnu", name: "À préciser" },
];

export const FINANCEMENT_CHOICES = [
  { id: "opco", name: "OPCO" },
  { id: "fonds_propres", name: "Fonds propres" },
  { id: "autre", name: "Autre" },
  { id: "inconnu", name: "À préciser" },
];

export const MOTIF_PERTE_CHOICES = [
  { id: "prix", name: "Prix" },
  { id: "timing", name: "Timing" },
  { id: "concurrent", name: "Concurrent" },
  { id: "sans-suite", name: "Sans suite" },
  { id: "autre", name: "Autre" },
];

export const LOST_STAGE = "perdu";

export const STAGE_PROBABILITIES: Record<string, number> = {
  "nouvelle-demande": 0.1,
  qualification: 0.3,
  "devis-a-preparer": 0.5,
  "devis-envoye": 0.7,
};
